module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTutorial) ? _c('div', [_c('div', {
    staticClass: "do-yt fadeIn js-dontCloseSidenav"
  }, [_c('div', {
    staticClass: "do-yt__container"
  }, [_c('div', {
    staticClass: "do-yt__container-close js-dontCloseSidenav",
    on: {
      "click": _vm.closeYouTubePopup
    }
  }, [_c('span', {
    staticClass: "icon-cross2 js-dontCloseSidenav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "do-yt__embed",
    class: {
      'scaleUp': _vm.classListTimeout
    }
  }, [_c('youtube', {
    ref: "youtube",
    attrs: {
      "video-id": _vm.videoId,
      "player-vars": _vm.videoVars
    },
    on: {
      "ready": _vm.videoReady,
      "cued": _vm.videoCued,
      "playing": _vm.videoPlaying,
      "ended": _vm.videoEnded
    }
  })], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e147b0f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YouTube/DoYouTube.vue
// module id = 1834
// module chunks = 1